<div class="grid flex align-items-center p-3" [class]="onExtendedMobile() ? 'justify-content-center' : 'justify-content-start'">
   <p-button id="addExclusionCalendar" label="{{ 'ADD_EXCLUSIONS_CALENDAR' | translate }}" (click)="addCalendarExclusion()" [disabled]="currentSite=== undefined || !currentSite.CurrentlyOwned"
      icon="pi cm-plus" [rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary">
   </p-button>
</div>

<p-accordion>
	<p-accordionTab *ngFor="let calendar of calendars">
		<ng-template pTemplate="header">
			<div class="grid flex align-items-center w-full pt-2 -mb-2">
				<div [class]="!onExtendedMobile() ? 'col-5' : 'col-12 flex justify-content-center'" class="py-0"><span class="font-bold white-space-nowrap">{{calendar.Name}}</span></div>
				<div [class]="!onExtendedMobile() ? 'col-5' : 'col-12 flex justify-content-center'" class="py-0"><span class="font-normal white-space-nowrap">{{calendar.Description}}</span></div>
				<div [class]="!onExtendedMobile() ? 'col-2 flex justify-content-end' : 'col-12 flex justify-content-center'" class="py-0 pr-0"> 
					<p-button pTooltip="{{ 'EDIT' | translate }}" class="" [disabled]="currentSite=== undefined || !currentSite.CurrentlyOwned"
						tooltipPosition="bottom" icon="pi cm-pencil" size="large"
						(click)="$event.stopPropagation(); editCalendarExclusion(calendar)" [rounded]="false" [text]="true" severity="secondary">
					</p-button>
					<p-button pTooltip="{{ 'DELETE' | translate }}" class="" [disabled]="currentSite=== undefined || !currentSite.CurrentlyOwned"
						tooltipPosition="bottom" icon="pi cm-trash" size="large"
						(click)="$event.stopPropagation(); deleteCalendarExclusion(calendar)" [rounded]="false" [text]="true" severity="danger">
					</p-button>
				</div>
			</div>
		</ng-template>
		<div>
			<app-exceptions-calendar [calendarId]="calendar.Id"></app-exceptions-calendar>
		</div>
	</p-accordionTab>
</p-accordion>

<p-confirmDialog #confDialog class="p-confirm-dialog-content">
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton
				[label]="confDialog.acceptButtonLabel"
				[ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton
				[label]="confDialog.rejectButtonLabel"
				[ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>
